module.exports = __webpack_public_path__ + "assets/dc5e3cecd1b402099782da5b7d608e43.mp4";